/// <reference types="@angular/localize" />

import { enableProdMode, ErrorHandler } from '@angular/core';
import { environment } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from '@app/app.component';
import { HTTP_INTERCEPTORS, HttpClientJsonpModule, HttpClientModule, provideHttpClient } from '@angular/common/http';
import { WINDOW_PROVIDERS } from '@shared/services/window.service';
import { HttpErrorHandlerService } from '@core/services/http-error-handler.service';
import { AppGlobalErrorHandler } from '@core/services/error-handler.service';
import { provideRouter, withEnabledBlockingInitialNavigation, withInMemoryScrolling } from '@angular/router';
import { APP_ROUTES } from '@app/app.routes';

if (environment.production) {
	enableProdMode();
}

bootstrapApplication(AppComponent, {
	providers: [
		provideRouter(
			APP_ROUTES,
			withEnabledBlockingInitialNavigation(),
			withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })
		),
		provideHttpClient(),
		HttpClientModule,
		HttpClientJsonpModule,
		WINDOW_PROVIDERS,
		{
			provide: HTTP_INTERCEPTORS,
			useClass: HttpErrorHandlerService,
			multi: true
		},
		{
			provide: ErrorHandler,
			useClass: AppGlobalErrorHandler
		}
	],
})
	.catch(err => console.log(err));
